import type { Season } from '@/types/visualEffects';

/**
 * Determine if it's currently Shabbat based on local time.
 * Simple implementation: Friday sunset (6pm) to Saturday sunset (6pm)
 */
export function isShabbat(): boolean {
  const now = new Date();
  const day = now.getDay();
  const hour = now.getHours();

  // Friday after 6pm
  if (day === 5 && hour >= 18) {
    return true;
  }

  // Saturday before 6pm
  if (day === 6 && hour < 18) {
    return true;
  }

  return false;
}

/**
 * Get current Jewish season based on current month.
 * This is a simplified approximation - for accuracy, would need Hebrew calendar integration.
 */
export function getCurrentSeason(_calendarItems?: unknown): Exclude<Season, 'auto'> {
  const now = new Date();
  const month = now.getMonth(); // 0-11

  // Approximate mapping:
  // Spring: March-May (Pesach period) - months 2-4
  // Summer: June-August (Shavuot period) - months 5-7
  // Autumn: September-November (High Holidays) - months 8-10
  // Winter: December-February (Chanukah period) - months 11, 0, 1

  if (month >= 2 && month <= 4) {
    return 'spring';
  } else if (month >= 5 && month <= 7) {
    return 'summer';
  } else if (month >= 8 && month <= 10) {
    return 'autumn';
  } else {
    return 'winter';
  }
}
